<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                <div style="display: flex; align-items: center;justify-content: space-between;" class="py-2">
                    <h4 class="custom-font"> Registration List</h4>
                    <button class="btn btn-success custom-font" type="button" style="margin: 5px;"
                        (click)="addNew()">Add
                        New Registration</button>
                </div>
            </div>
        </div>
        <div class="card row">
            <div class=" col-lg-12 col-md-12 col-12 p-4">
                <div class="row">
                    <div class="col-md-11">
                        <div class="py-3">
                            <input type="text" id="searchtext" class="form-control bg-white border-0 small"
                                placeholder="Search for..." [(ngModel)]="searchtext" aria-label="Search"
                                aria-describedby="basic-addon2" />
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="py-3">
                        <button class="btn btn-success" (click)="getRegistrationList(1);"
                            style="margin: 5px;">Search</button>
                            </div>
                    </div>
                </div>
                <div class="table-responsive" style="min-height: 500px;">
                    <table id="example" class="table table-striped table-bordered" style="width:100%;">
                        <thead>
                            <tr>
                                <!-- <th class="pointer"(click)="sortBy('Board')">Name</th> -->
                                <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.</th>
                                <th class="pointer" scope="col" (click)="sortBy('Board')"> University </th>
                                <th class="pointer" scope="col" (click)="sortBy('Medium')">Medium</th>
                                <!-- <th class="pointer" scope="col" (click)="sortBy('Office')">Office</th> -->
                                <th class="pointer" scope="col" (click)="sortBy('TypeOfTrust')">Type Of Trust</th>
                                <th class="pointer" scope="col" (click)="sortBy('Section')">Section</th>
                                <th class="pointer" scope="col" (click)="sortBy('SchoolName')">College Name</th>
                                <th class="pointer" scope="col" (click)="sortBy('CollegeCode')">College Code</th>
                                <th class="pointer" scope="col" (click)="sortBy('SchoolMailID')">College Mail ID</th>
                                <th class="pointer" scope="col" (click)="sortBy('Status')">Status</th>
                                <th class="pointer" scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="registrationlist != undefined && registrationlist.length != 0"
                            style="font-size: small;">
                            <!-- <tr
                                *ngFor="let r of registrationlist | paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index"> -->
                                <tr *ngFor="let r of registrationlist | paginate: { itemsPerPage: pageLimit,currentPage: p ,totalItems: totalRegistration};let i = index">
                                <td>{{r.SrNo}}</td>
                                <td>
                                    <p>{{r.Board}}</p>
                                </td>
                                <td width='15%'>
                                    <p>{{r.Medium}}</p>
                                </td>
                                <!-- <td>
                                    <p>{{r.Office}}</p>
                                </td> -->
                                <td>
                                    <p>{{r.TypeOfTrust}}</p>
                                </td>
                                <td>
                                    <p>{{r.Section}}</p>
                                </td>
                                <td>
                                    <p>{{r.SchoolName}}</p>
                                </td>
                                <td>
                                    <p>{{r.CollegeCode}}</p>
                                </td>
                                <td>
                                    <p>{{r.SchoolMailID}}</p>
                                </td>
                                <td>
                                    <!-- <p *ngIf="r.Status == 1">Deactive</p>
                                    <p *ngIf="r.Status == 0">Active</p> -->
                                    <div *ngIf="r.Status == 'Active'; then thenBlock else elseBlock"></div>
                                    <ng-template #thenBlock>
                                        <span class="badge badge-success" style="font-size: larger;">Active</span>
                                    </ng-template>
                                    <ng-template #elseBlock>
                                        <span class="badge badge-danger" style="font-size: larger;">Deactive</span>
                                    </ng-template>
                                </td>
                                <td style="white-space: nowrap;">
                                    <!-- <button type="button" class="btn btn-success"
                                        (click)="editRegistration(r.HashCode)">Edit</button> -->
                                    <!-- &nbsp; <button type="button" class="btn btn-danger " *ngIf="r.Status == 0"
                                        (click)="deleteRegistration(r.ID,1)">Deactivate School</button> -->
                                    <!-- &nbsp; <button type="button" class="btn btn-danger" *ngIf="r.Status == 1"
                                        (click)="deleteRegistration(r.ID,0)">Activate School</button> -->
                                    <!-- &nbsp; <button type="button" class="btn btn-primary"
                                        (click)="allocateFees(r.HashCode)">Allocate Fees</button> -->
                                    <!-- &nbsp; <button type="button" class="btn btn-success"
                                        *ngIf="r.ViewAllocateRequestBtn > 0" (click)="viewRequest(r.HashCode)">View
                                        Allocates</button> -->
                                    <div class="dropdown">
                                        <button class="btn btn-success dropdown-toggle" id="dropdownFadeInUp"
                                            type="button" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            <i class="fa fa-cog"></i>
                                        </button>
                                        <div class="dropdown-menu animated--fade-in-up"
                                            aria-labelledby="dropdownFadeInUp">
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="editRegistration(r.HashCode)">Edit</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="viewProfile(r.HashCode,r.SchoolName)">View profile</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="resendPassword(r.SchoolMailID)">Resend login credential</a>
                                            <a class="dropdown-item" href="javascript:void(0);" *ngIf="r.Status == 0"
                                                (click)="deleteRegistration(r.ID,1)">Deactivate college</a>
                                            <a class="dropdown-item" href="javascript:void(0);" *ngIf="r.Status == 1"
                                                (click)="deleteRegistration(r.ID,0)">Activate college</a>
                                            <!-- <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="allocateFees(r.HashCode,r.SchoolName)">Allocate Fees</a> -->
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                *ngIf="r.ViewAllocateRequestBtn > 0"
                                                (click)="viewRequest(r.HashCode,r.SchoolName)">View allocated fees</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="infrastructureDetail(r.HashCode,r.SchoolName)">Infrastructure
                                                detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="classroomDetail(r.HashCode,r.SchoolName)">ClassRoom detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="bookDetail(r.HashCode,r.SchoolName)">Book detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="landownerDetail(r.HashCode,r.SchoolName)">Land Owner detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="employeeadditionaldetail(r.HashCode,r.SchoolName)">Employee
                                                additional detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="expenseDetail(r.HashCode,r.SchoolName)">Expense detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="rentalDetail(r.HashCode,r.SchoolName)">Rental detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="establishmentDetail(r.HashCode,r.SchoolName)">Establishment
                                                detail</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="ViewScholarship(r.HashCode,r.SchoolName)">View scholarship</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="ViewDocumentUpload(r.HashCode,r.SchoolName)">Document
                                                upload</a>
                                            <a class="dropdown-item" href="javascript:void(0);"
                                                (click)="ViewConstructionDetail(r.HashCode,r.SchoolName)"> Construction
                                                Detail</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="registrationlist == undefined || registrationlist.length == 0">
                            <tr>
                                <td colspan="10" style="text-align: center;">
                                    No record found
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="registrationlist != undefined && registrationlist.length != 0"
                    class="card-footer pb-3 pt-3 mb-4" align="center">
                    <!-- <pagination-controls (pageChange)="p = $event"></pagination-controls> -->
                    <pagination-controls (pageChange)="getRegistrationList($event)" responsive="true"
                        maxSize="{{totalPages}}"></pagination-controls>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>